import { RootState } from '../../app/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const localizationSlice = createSlice({
    name: 'localization',
    initialState: {
        translationLoader: false,
        locale: null,
    } as any,
    reducers: {
        setTranslationLoader: (state: RootState, action: PayloadAction<any>) => {
            state.translationLoader = action.payload;
        },
        setLocale: (state: RootState, action: PayloadAction<any>) => {
            state.locale = action.payload;
        },
    },
});

export const { setTranslationLoader, setLocale } = localizationSlice.actions;
export const selectTranslationLoader = (state: RootState): boolean => state.localization.translationLoader;
export const selectLocale = (state: RootState): string => state.localization.locale;
export default localizationSlice;
